import { VydejMenu } from '../../vydej/vydejmenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import { PriceListItem } from '../../priceList/components/PriceListItem';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

const VydejPriceListItemDetailPage = () => {
  const { apps, customerType } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.vydej && customerType === 'ipr' ? (
        <AppWrapper
          appType={APP_TYPE.VYDEJ}
          menu={<VydejMenu />}
          resource='PriceListItems'
          action='retrieve'
        >
          <PriceListItem />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default VydejPriceListItemDetailPage;
